import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
} from 'material-ui'

import {ClickAwayListener} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import {Logout} from '../helper/functions'

import '../styles/ToolbarMenuIcon.css'

const style = {
  toolbarMenuIcon:{
    marginLeft:'9px',
  }
}

export default class ToolbarMenuIcon extends Component{
  constructor(props){
    super(props);

    this.state = {
      open:false,
    }
  }

  handleMenuIconClick=()=>{
    this.setState({
      open:!this.state.open,
    })
  }

  handleRequestClose=(e)=>{
    this.setState({open:false})
  }

  logout=()=>{
    this.setState({open:false})
    Logout();
  }

  closeMenu=()=>{
    if(this.state.open){
      this.setState({open:false})
    }
  }

  render(){
    const {uid,user} = this.props;
    return(
      <ClickAwayListener onClickAway={this.closeMenu} >
        <div style={style.toolbarMenuIcon} className="toolbarMenuIcon">
          <Avatar
            src={user.photoURL ? user.photoURL : null}
            alt={user.displayName}
            className='avatar'
            onClick={this.handleMenuIconClick}
          >
            {user.photoURL ? null : user.displayName?user.displayName[0]:user.email[0]}
          </Avatar>
          {this.state.open?
            <Fade
              in={this.state.open}
            >
              <Paper
                elevation={10}
                className='menu'
              >
                <List>
                  <Link to={'/Profile'} >
                    <ListItem onClick={this.handleRequestClose} button >
                      <Avatar
                        src={user.photoURL ? user.photoURL : null}
                        alt={user.displayName}
                        className='avatar'
                      >
                        {user.photoURL ? null : user.displayName?user.displayName[0]:user.email[0]}
                      </Avatar>
                      <ListItemText primary={`${user.displayName?user.displayName:''}`} />
                    </ListItem>
                  </Link>
                  <Divider light />
                  <Link to={`/User/${uid}`} >
                    <ListItem onClick={this.handleRequestClose} button >
                      <ListItemText primary="Public Profile" />
                    </ListItem>
                  </Link>
                  <Divider light />
                  <Link to={'/Settings'} >
                    <ListItem onClick={this.handleRequestClose} button >
                      <ListItemText primary="Settings" />
                    </ListItem>
                  </Link>
                  <Divider light />

                  <ListItem onClick={this.logout} button >
                    <ListItemText primary="Logout" />
                  </ListItem>

                </List>
              </Paper>
            </Fade>
          :
            null
          }
        </div>
      </ClickAwayListener>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ToolbarMenuIcon.js